module.exports = __webpack_public_path__ + "static/media/ManjimupBridgetownTimes-devicecomp-min.4ae36e23.png";